import React from "react";
import { MainLayout } from "../../MainLayout";
import { MalaysiaSec1Data } from "../../../Data/IndiaSec1Data";
import { Footer } from "../../Footer";
import { IndiaSec4 } from "../India/IndiaSec4/IndiaSec4";
import { IndiaSec1 } from "../India/IndiaSec1/IndiaSec1";
import { IndiaSec2 } from "../India/IndiaSec2/IndiaSec2";
import { IndiaSec3 } from "../India/IndiaSec3/IndiaSec3";

export const Malaysia = () => { 

    const destinationPackages = [
        {
            mapImg: "/assets/malaysia-air.png",
            sliderimg: [
                {
                    id: 1,
                    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Truly%20Asia%20Discovery/truly_asia_2.webp",
                    title: "",
                },
                {
                    id: 2,
                    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Truly%20Asia%20Discovery/truly_asia_3.webp",
                    title: "",
                },
            ],
            title: "4N/5D Truly Asia Discovery",
            days: "4N/5D",
            tags: ["WaterFall", "Temples", "Sightseeing"],
            description:
                "Discover the essence of Malaysia – Truly Asia with this 4 Nights & 5 Days journey that blends culture, adventure, and modern charm. From the bustling streets and dazzling skyline of Kuala Lumpur to the cool highlands of Genting and the thrill of Sunway Lagoon Theme Park, this itinerary captures Malaysia’s diversity at its finest. Whether you’re exploring iconic landmarks, soaring on cable cars, or enjoying family fun at world-class attractions, every moment of this tour is designed to delight and inspire.",
            img: "/assets/india-ite-char-dham.jpeg",
            slug: "trulyAsiaDiscovery",
        },
        {
            title: "3N/4D Discover Malaysia ",
            days: "3N/4D",
            tags: ["Sightseeing", "Mountain", "Lakes"],
            description:
                "Experience the best of Malaysia’s mountain and city charm with this 4-day Discover Malaysia Package. Begin your journey amidst the cool misty hills of Genting Highlands, known for its cable car rides, shopping outlets, and entertainment venues. Continue to the vibrant capital city of Kuala Lumpur, where modern skyscrapers blend seamlessly with cultural heritage sites. This perfectly balanced itinerary offers a mix of relaxation, sightseeing, and excitement — ideal for travelers seeking a short yet memorable Malaysian getaway. ",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Discover%20Malaysia/Discover_Malaysia_2.webp",
            slug: "discoverMalaysia",
        },
        {
            title: "3N/4D Explore Malaysia",
            days: "3N/4D",
            tags: ["WildLife", "Boat House", "WaterFall"],
            description:
                "Discover the vibrant charm of Malaysia with this 4-day Explore Malaysia Package, featuring the best of Kuala Lumpur and Genting Highlands. Marvel at the city’s iconic skyline, including the KL Tower Observation Deck, and immerse yourself in the rich culture and modern attractions of the capital. Take a scenic trip to the cool hills of Genting Highlands, home to casinos, theme parks, and breathtaking views. This package combines comfort, sightseeing, and leisure—perfect for travelers seeking a memorable Malaysian escape.",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Explore%20Malaysia/explore_malaysia_2.webp",

            slug: "exploreMalaysia",
        },
    ];

    const topcitydata = [
        {
            id: 1,
            title: "Kuala Lumpur",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Kuala%20Lumpur%20Malaysia.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>The energetic capital of Malaysia combines
                    global connectivity with local character. Known for its modern
                    skyline, shopping districts, and vibrant nightlife, Kuala Lumpur
                    serves as a commercial hub and gateway to the rest of the country.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Petronas Twin Towers, Bukit Bintang,
                    KL Tower, Merdeka Square, Chinatown.
                </p>,
            ],
        },
        {
            id: 2,
            title: "Langkawi",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Malaysia%20top%20places/Malaysia%20top%20places/Langkawi.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>A cluster of 99 islands in the Andaman
                    Sea, Langkawi is where turquoise waters meet rainforest hills. It’s a
                    duty-free paradise and a prime destination for luxury, wellness, and
                    eco-conscious travel experiences.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Langkawi Sky Bridge, Cable Car,
                    Pantai Cenang Beach, Kilim Geoforest Park.
                </p>,
            ],
        },
        {
            id: 3,
            title: "Penang",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Malaysia%20top%20places/Malaysia%20top%20places/Penang.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Famed for heritage and innovation, Penang
                    offers a flawless balance between colonial charm and creative culture.
                    It’s a destination that appeals to history buffs, art lovers, and
                    culinary explorers alike.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>George Town UNESCO Site, Kek Lok Si
                    Temple, Penang Hill, Clan Jetties.
                </p>,
            ],
        },
        {
            id: 4,
            title: "Genting Highlands",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Malaysia%20top%20places/Malaysia%20top%20places/Genting%20Highlands.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Set in the Titiwangsa Mountains, Genting
                    Highlands offers a unique high-altitude entertainment retreat. It’s
                    home to casinos, theme parks, and high-end hotels, attracting both
                    leisure and corporate groups.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Genting SkyWorlds Theme Park, Awana
                    SkyWay, Casinos, Chin Swee Temple.
                </p>,
            ],
        },
        {
            id: 5,
            title: "Malacca (Melaka)",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Malacca.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>A UNESCO World Heritage city, Malacca
                    tells the story of Malaysia’s colonial past through its architecture,
                    cuisine, and waterways. It’s a historical gem ideal for educational,
                    heritage, and group travel.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Dutch Square, A Famosa Fort, Jonker
                    Street, Melaka River Cruise.
                </p>,
            ],
        },
        {
            id: 6,
            title: "Cameron Highlands",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Malaysia%20top%20places/Malaysia%20top%20places/Cameron%20Highlands.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Known for its endless tea gardens and cool
                    climate, Cameron Highlands is Malaysia’s green escape. It’s popular
                    among families and wellness travelers seeking peace, scenic beauty,
                    and sustainable tourism.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>BOH Tea Estate, Strawberry Farms,
                    Mossy Forest, Cameron Lavender Garden.
                </p>,
            ],
        },
        {
            id: 7,
            title: "Borneo (Sabah & Sarawak)",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Borneo.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>A haven for nature and adventure
                    enthusiasts, Malaysian Borneo is home to rainforests, rare wildlife,
                    and tribal cultures. It’s one of Asia’s best regions for eco-tourism
                    and sustainable travel projects.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Mount Kinabalu, Sepilok Orangutan
                    Centre, Bako National Park, Mulu Caves.
                </p>,
            ],
        },
        {
            id: 8,
            title: "Putrajaya",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Malaysia%20top%20places/Malaysia%20top%20places/Putrajaya.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Malaysia’s planned city showcases
                    futuristic architecture and government landmarks. With its world-class
                    convention centers and scenic lakefront views, it’s ideal for MICE,
                    incentive, and corporate travel.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Putra Mosque, Putrajaya Lake, Seri
                    Wawasan Bridge, Botanical Garden.
                </p>,
            ],
        },
        {
            id: 9,
            title: "Perhentian Islands",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Malaysia%20top%20places/Malaysia%20top%20places/Perhentian%20Islands.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Known for crystal-clear waters and coral
                    reefs, the Perhentian Islands offer an idyllic escape for diving,
                    snorkeling, and barefoot luxury. It’s a go-to destination for leisure
                    groups and youth travel programs.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Long Beach, Coral Bay, Snorkeling &
                    Diving Spots, Turtle Sanctuary.
                </p>,
            ],
        },
        {
            id: 10,
            title: "Ipoh",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Malaysia%20top%20places/Malaysia%20top%20places/Ipoh.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Once a tin-mining town, Ipoh has evolved
                    into a chic heritage destination with boutique stays and creative
                    cafés. Its colonial charm and limestone hills make it perfect for slow
                    travel and cultural discovery.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Kek Lok Tong Cave Temple, Ipoh Old
                    Town, Concubine Lane, Lost World of Tambun.
                </p>,
            ],
        },
    ];

    const data = [
        {
            id: 1,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon1.png",
            title: "City + Beach Planning",
            desc: "Malaysia itineraries are usually built around Kuala Lumpur with a second destination like Langkawi or Penang, balancing sightseeing with relaxation."
        },
        {
            id: 2,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon2.png",
            title: "Flexible Travel Durations",
            desc: "Programs can be adjusted between 3 to 6 nights depending on the client profile, with shorter stays focused on Kuala Lumpur and longer trips including islands or cultural regions."
        },
        {
            id: 3,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon3.png",
            title: "Easy Inter-City Movement",
            desc: "Travel between destinations is simple with frequent domestic flights and strong road connectivity, making multi-city planning smooth and efficient."
        },
        {
            id: 4,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon4.png",
            title: "Kuala Lumpur City Experiences",
            desc: "Visits typically include areas around the Petronas Twin Towers, shopping districts, and nearby attractions, all accessible without long travel times."
        },
        {
            id: 5,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon5.png",
            title: "Island Stay Planning",
            desc: "Destinations like Langkawi are planned for slower-paced, relaxing stays, usually positioned at the end of the itinerary for a comfortable experience."
        },
        {
            id: 6,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon6.png",
            title: "Area-Wise Hotel Selection",
            desc: "City hotels are selected in central locations, while island stays focus on beachfront or resort properties to ensure convenience throughout the journey."
        },
        {
            id: 7,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon7.png",
            title: "Planned & Free Time",
            desc: "Itineraries combine guided sightseeing with free time, allowing travelers flexibility for shopping, dining, or exploring independently."
        },
        {
            id: 8,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon8.png",
            title: "Seasonal Travel Consideration",
            desc: "Travel plans are adjusted based on seasonal patterns to avoid heavy rains, especially for island destinations, ensuring a smooth overall experience."
        },
    ];
    return (
        <>
            <MainLayout bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/new%20Main%20banner%20malayasia.webp")'}
                text2={"Malaysia"}
                button={true} />
            <IndiaSec1 IndiaSec1Data={MalaysiaSec1Data} />
             <IndiaSec2 countryCode="MY" />
            <IndiaSec3 data={topcitydata} name={"Malaysia"} />
            <IndiaSec4
                data={data}
                heading={"Discover What We Bring to Malaysia "}
            />
            <Footer />

        </>
    )


};